import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data
   
  };
};
export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("order_declination_reasons.reason_en")}*`,
        width: "47%",
        placeholder: t("order_declination_reasons.write_reason_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("order_declination_reasons.reason_ar"),
        width: "47%",
        placeholder: t("order_declination_reasons.write_reason_ar"),
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    ar: Yup.object().shape({
      name: Yup.string(),
    }),
  });
